<template>
  <div class="m-0 dbozone-font body">
    <div>
      <div class="col-12 justify-content-center d-flex flex-row header-aztec1000">
        <div class="px-3 col-3 p-0">
          <div class="heading-aztec1000">{{ $t("result.round") }}</div>
          <div class="text-subhead-aztec1000">{{ data.roundId }}</div>
        </div>
        <div class="px-3 col-3">
          <div class="heading-aztec1000">
            {{ $t("result.bet") + `${currency}` }}
          </div>
          <div class="text-subhead-aztec1000">
            {{ data.count === 0
              ? data.bet
              : data.detail.summary[data.count].bet.amount | currencyFormatter }}
          </div>
        </div>
        <div class="px-3 col-3">
          <div class="heading-aztec1000">
            {{ $t("result.winlose") + `${currency}` }}
          </div>
          <div class="text-subhead-aztec1000">
            {{ winlose | currencyFormatter }}
          </div>
        </div>
        <div class="px-3 col-3">
          <div class="heading-aztec1000">
            {{ $t("result.balance") + `${currency}` }}
          </div>
          <div class="text-subhead-aztec1000">
            {{ balance | currencyFormatter }}
          </div>
        </div>
      </div>
      <div class="content-result-aztec1000 pt-3">
        <div class="text-games-aztec1000">{{ "Aztec Empire 1000" }}</div>
        <div class="text-subgame-aztec1000">{{ $t("aztec1000.name") }}</div>
        <div class="text-date mb-1">{{ data.timestamp }}</div>
        <div class="col-12 justify-content-center d-flex flex-row p-0" style="margin-top: 50px">
          <div class="col-1 d-flex align-items-center justify-content-center" style="color: white">
            <i v-if="isFreespin || isRespin || isGamble" class="fas fa-caret-left arrow-side-aztec1000"
              @click="delCount()"></i>
          </div>

          <!-- <div class="d-flex col-10 table-aztec1000 container" /> -->
          <!-- <div v-if="this.isGamble === true">
            <div v-if="this.freeSpinData.gamble != '-'">
              <div class="d-flex flex-column align-items-center justify-content-center pt-10">
                <img class="gamble-img-aztec1000" :src="require(`../../assets/resultGame/aztec1000/gamble/history_${this.winGambleText}.png`)
                  " alt="" />
              </div>
              <div class="d-flex flex-column align-items-center justify-content-center">
                <img class="gamble-img-aztec1000" :src="require(`../../assets/resultGame/aztec1000/gamble/wheel_${this.freeSpinData.gambleThisRound}_${this.winGambleText}.png`)
                  " alt="" />
              </div>
            </div>
            <div v-else-if="this.freeSpinData.gamble == '-'">
              <div class="d-flex flex-column align-items-center justify-content-center">
                <div class="text-collect-aztec1000 d-flex">
                  {{ $t("result.collect") + " = " }}
                  {{ this.freeSpinData.totalWin | currencyFormatter }}
                  {{ `(${currency})` }}
                </div>
                <img class="gamble-img-aztec1000" :src="require(`../../assets/resultGame/aztec1000/gamble/btn_collect.png`)
                  " alt="" />
              </div>
            </div>
            <div v-if="this.freeSpinData.gamble === 'LOW'">
              <div class="col-12 justify-content-center d-flex flex-row">
                <img class="gamble-press-aztec1000 pt-0" :src="require(`../../assets/resultGame/aztec1000/gamble/btn_LOW_${this.winGambleText}.png`)
                  " alt="" />
                <img class="gamble-normal-aztec1000 pt-2" :src="require(`../../assets/resultGame/aztec1000/gamble/btn_HIGH_normal.png`)
                  " alt="" />
              </div>
            </div>
            <div v-else-if="this.freeSpinData.gamble === 'HIGH'">
              <div class="col-12 justify-content-center d-flex flex-row">
                <img class="gamble-press-aztec1000 pt-2" :src="require(`../../assets/resultGame/aztec1000/gamble/btn_LOW_normal.png`)
                  " alt="" />
                <img class="gamble-normal-aztec1000 pt-0" :src="require(`../../assets/resultGame/aztec1000/gamble/btn_HIGH_${this.winGambleText}.png`)
                  " alt="" />
              </div>
            </div>
          </div>
          <div v-else> -->
          <div class="d-flex flex-column">
            <div class="top-reel justify-content-center">
              <div class="" v-for="(row, index) in reels[6]" :key="index">
                <img v-if="row === 13" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/1/symbol_${row}_x${reelsMultiplier[6][index]}.png`)
                  " alt="" />
                <img v-else class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/1/symbol_${row}.png`)
                  " alt="" />
              </div>
            </div>

            <div class="d-flex flex-row slot-container">

              <div class="d-flex flex-column">
                <div v-for="(reel, index) in reels[0]" :key="index">
                  <img v-if="reel >= 0 && reel <= 12" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/${reelSizes[0][index]}/symbol_${reel}.png`)
                    " alt="" />
                  <img v-if="reel === 13" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/1/symbol_${reel}_x${reelsMultiplier[0][index]}.png`)
                    " alt="" />
                  <img v-if="reel >= 14 && reel <= 24" class="icon-symbol-aztec1000"
                    :class="`-level${reelSizes[0][index]}`" :src="require(`../../assets/resultGame/aztec1000/${reelSizes[0][index]
                      }/symbol_${reel - 14}.png`)
                      " alt="" />
                  <img v-if="reel >= 14 && reel <= 24" class="icon-symbol" :class="`-level${reelSizes[0][index]}`" :src="require(`../../assets/resultGame/aztec1000/silver${reelSizes[0][index]}.png`)
                    " alt="" />
                  <img v-if="reel >= 25 && reel <= 35" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/${reelSizes[0][index]
                    }/symbol_${reel - 25}.png`)
                    " alt="" />
                  <img v-if="reel >= 25 && reel <= 35" class="icon-symbol" :class="`-level${reelSizes[0][index]}`" :src="require(`../../assets/resultGame/aztec1000/gold${reelSizes[0][index]}.png`)
                    " alt="" />
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="" v-for="(reel, index) in reels[1]" :key="index">
                  <img v-if="reel >= 0 && reel <= 12" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/${reelSizes[1][index]}/symbol_${reel}.png`)
                    " alt="" />
                  <img v-if="reel === 13" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/1/symbol_${reel}_x${reelsMultiplier[1][index]}.png`)
                    " alt="" />
                  <img v-if="reel >= 14 && reel <= 24" class="icon-symbol-aztec1000"
                    :class="`-level${reelSizes[1][index]}`" :src="require(`../../assets/resultGame/aztec1000/${reelSizes[1][index]
                      }/symbol_${reel - 14}.png`)
                      " alt="" />
                  <img v-if="reel >= 14 && reel <= 24" class="icon-symbol" :class="`-level${reelSizes[1][index]}`" :src="require(`../../assets/resultGame/aztec1000/silver${reelSizes[1][index]}.png`)
                    " alt="" />
                  <img v-if="reel >= 25 && reel <= 35" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/${reelSizes[1][index]
                    }/symbol_${reel - 25}.png`)
                    " alt="" />
                  <img v-if="reel >= 25 && reel <= 35" class="icon-symbol" :class="`-level${reelSizes[1][index]}`" :src="require(`../../assets/resultGame/aztec1000/gold${reelSizes[1][index]}.png`)
                    " alt="" />
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="" v-for="(reel, index) in reels[2]" :key="index">
                  <img v-if="reel >= 0 && reel <= 12" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/${reelSizes[2][index]}/symbol_${reel}.png`)
                    " alt="" />
                  <img v-if="reel === 13" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/1/symbol_${reel}_x${reelsMultiplier[2][index]}.png`)
                    " alt="" />
                  <img v-if="reel >= 14 && reel <= 24" class="icon-symbol-aztec1000"
                    :class="`-level${reelSizes[2][index]}`" :src="require(`../../assets/resultGame/aztec1000/${reelSizes[2][index]
                      }/symbol_${reel - 14}.png`)
                      " alt="" />
                  <img v-if="reel >= 14 && reel <= 24" class="icon-symbol" :class="`-level${reelSizes[2][index]}`" :src="require(`../../assets/resultGame/aztec1000/silver${reelSizes[2][index]}.png`)
                    " alt="" />
                  <img v-if="reel >= 25 && reel <= 35" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/${reelSizes[2][index]
                    }/symbol_${reel - 25}.png`)
                    " alt="" />
                  <img v-if="reel >= 25 && reel <= 35" class="icon-symbol" :class="`-level${reelSizes[2][index]}`" :src="require(`../../assets/resultGame/aztec1000/gold${reelSizes[2][index]}.png`)
                    " alt="" />
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="" v-for="(reel, index) in reels[3]" :key="index">
                  <img v-if="reel >= 0 && reel <= 12" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/${reelSizes[3][index]}/symbol_${reel}.png`)
                    " alt="" />
                  <img v-if="reel === 13" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/1/symbol_${reel}_x${reelsMultiplier[3][index]}.png`)
                    " alt="" />
                  <img v-if="reel >= 14 && reel <= 24" class="icon-symbol-aztec1000"
                    :class="`-level${reelSizes[3][index]}`" :src="require(`../../assets/resultGame/aztec1000/${reelSizes[3][index]
                      }/symbol_${reel - 14}.png`)
                      " alt="" />
                  <img v-if="reel >= 14 && reel <= 24" class="icon-symbol" :class="`-level${reelSizes[3][index]}`" :src="require(`../../assets/resultGame/aztec1000/silver${reelSizes[3][index]}.png`)
                    " alt="" />
                  <img v-if="reel >= 25 && reel <= 35" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/${reelSizes[3][index]
                    }/symbol_${reel - 25}.png`)
                    " alt="" />
                  <img v-if="reel >= 25 && reel <= 35" class="icon-symbol" :class="`-level${reelSizes[3][index]}`" :src="require(`../../assets/resultGame/aztec1000/gold${reelSizes[3][index]}.png`)
                    " alt="" />
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="" v-for="(reel, index) in reels[4]" :key="index">
                  <img v-if="reel >= 0 && reel <= 12" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/${reelSizes[4][index]}/symbol_${reel}.png`)
                    " alt="" />
                  <img v-if="reel === 13" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/1/symbol_${reel}_x${reelsMultiplier[4][index]}.png`)
                    " alt="" />
                  <img v-if="reel >= 14 && reel <= 24" class="icon-symbol-aztec1000"
                    :class="`-level${reelSizes[4][index]}`" :src="require(`../../assets/resultGame/aztec1000/${reelSizes[4][index]
                      }/symbol_${reel - 14}.png`)
                      " alt="" />
                  <img v-if="reel >= 14 && reel <= 24" class="icon-symbol" :class="`-level${reelSizes[4][index]}`" :src="require(`../../assets/resultGame/aztec1000/silver${reelSizes[4][index]}.png`)
                    " alt="" />
                  <img v-if="reel >= 25 && reel <= 35" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/${reelSizes[4][index]
                    }/symbol_${reel - 25}.png`)
                    " alt="" />
                  <img v-if="reel >= 25 && reel <= 35" class="icon-symbol" :class="`-level${reelSizes[4][index]}`" :src="require(`../../assets/resultGame/aztec1000/gold${reelSizes[4][index]}.png`)
                    " alt="" />
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="" v-for="(reel, index) in reels[5]" :key="index">
                  <img v-if="reel >= 0 && reel <= 12" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/${reelSizes[5][index]}/symbol_${reel}.png`)
                    " alt="" />
                  <img v-if="reel === 13" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/1/symbol_${reel}_x${reelsMultiplier[5][index]}.png`)
                    " alt="" />
                  <img v-if="reel >= 14 && reel <= 24" class="icon-symbol-aztec1000"
                    :class="`-level${reelSizes[5][index]}`" :src="require(`../../assets/resultGame/aztec1000/${reelSizes[5][index]
                      }/symbol_${reel - 14}.png`)
                      " alt="" />
                  <img v-if="reel >= 14 && reel <= 24" class="icon-symbol" :class="`-level${reelSizes[5][index]}`" :src="require(`../../assets/resultGame/aztec1000/silver${reelSizes[5][index]}.png`)
                    " alt="" />
                  <img v-if="reel >= 25 && reel <= 35" class="icon-symbol-aztec1000" :src="require(`../../assets/resultGame/aztec1000/${reelSizes[5][index]
                    }/symbol_${reel - 25}.png`)
                    " alt="" />
                  <img v-if="reel >= 25 && reel <= 35" class="icon-symbol" :class="`-level${reelSizes[5][index]}`" :src="require(`../../assets/resultGame/aztec1000/gold${reelSizes[5][index]}.png`)
                    " alt="" />
                </div>
              </div>
            </div>
          </div>
          <!-- </div> -->

          <div class="col-1 d-flex align-items-center justify-content-center">
            <i v-if="!isEndRound" class="fas fa-caret-right arrow-side-aztec1000" @click="addCount()"></i>
          </div>
        </div>
        <div class="text-center py-4 text-games-aztec1000">
          <h1 v-if="isFreespin">
            {{ $t("result.freespin") }} {{ data.count + 1 }}/{{ data.detail.summary.length }}
          </h1>
          <h1 v-else>{{ $t("main-game.spin") }} {{ data.count + 1 }}/{{ data.detail.summary.length }}</h1>
        </div>
        <div v-if="winnings.length > 0 || winlose > 0" class="col-12 justify-content-center d-flex flex-row">
          <hr class="line col-3" />
          <div class="text-detail align-items-center d-flex px-3">
            {{ $t("result.detail") }}
          </div>
          <hr class="line col-3" />
        </div>
        <div v-if="data.detail.featureBuy" class="text-subgame-aztec1000">
          {{ $t("featurebuy.title") }}
        </div>

        <!-- <div v-if="data.detail.winnings.length" class="col-12 justify-content-start d-flex flex-row">
          <div class="bet-box-aztec1000 p-2 px-3 justify-content-start align-items-start container" style="width: 100%; align-content: center;">
            <div class="text-multiplier">
              <h1 class="my-1 green">Multiplier x {{ this.multiplier }}</h1>
            </div>
            <div class="bet-warpper item" v-for="(detail, index) in data.detail.winnings" :key="index">
              <div class="d-flex item justify-content-between px-1 mb-2" >
                <div class="bet-wrapper-aztec1000 item win-box d-flex" >
                  <div class="d-flex justify-content-between bet-wrapper-aztec1000 item">
                    <div class="d-flex flex-row">
                      <img class="icon-detail-aztec1000" :src="require(`../../assets/resultGame/aztec1000/1/symbol_${detail.symbol}.png`)
                        " alt="" />
                      <div class="d-flex flex-column align-items-start justify-content-center">
                        <p class="my-1 green ml-2">
                          {{
                            ` ${detail.row} ` +
                            $t("result.kind") +
                            ` x${detail.count} ${detail.count > 1 ? `lines` : `line`
                            }`
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="d-flex flex-column justify-content-center px-3">
                      <p class="my-1">
                        {{ currency }} {{ detail.amount | currencyFormatter }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->



        <div class="col-12 justify-content-start d-flex flex-row">
          <div class=" p-2 px-3 justify-content-start align-items-center container">
            <div class="text-multiplier">
              <h1 class="my-1 green">{{ $t("result.multiplier") }} x {{ this.multiplier }}</h1>
            </div>

            <div v-if="this.freespinFirstRound === true || this.retrigger">
              <div class="bet-wrapper justify-content-between item d-flex flex-row col-12 pt-2">
                <div class="d-flex flex-row">
                  <div style="margin-left:10px" class=" d-flex text-win align-items-center 
                            justify-content-center">
                    <img class="icon-detail-aztec1000"
                      :src="require(`../../assets/resultGame/aztec1000/1/symbol_11.png`)" alt="" />

                    <p class="pl-4 multiplier-text">
                      {{ `x ${this.scatterCount}` }}
                    </p>
                  </div>
                </div>
                <div class="d-flex text-win justify-content-center align-items-center px-3">
                  <p class="my-1 green" v-if="this.retrigger"> {{ `${this.freespinCount} ` + $t("result.freespin") }}
                  </p>
                  <p class="my-1 green" v-else> {{ `${this.freespinCount} ` + $t("result.freespin") }}</p>
                </div>
              </div>
            </div>

            <div v-if="winnings.length">
              <div class="bet-wrapper justify-content-between item d-flex flex-row col-12 pt-2"
                v-for="(detail, index) in winnings" :key="index">
                <div class="d-flex flex-row">
                  <div style="margin-left:10px" class=" d-flex text-win align-items-center 
                            justify-content-center">
                    <img class="icon-detail-aztec1000"
                      :src="require(`../../assets/resultGame/aztec1000/1/symbol_${detail.symbol}.png`)" alt="" />
                    <p class="my-1 pl-4">
                      <span class="multiplier-text">{{ `${detail.row}` + ' ' }}</span>
                      <span class="my-1 green">{{ $t("result.kind") }}</span>
                      <span class="multiplier-text">{{ ` X${detail.count}` }}</span>
                    </p>
                  </div>
                </div>
                <div class="d-flex text-win justify-content-center align-items-center px-3">
                  <p class="my-1 green"> {{ currency }} {{ detail.amount | currencyFormatter }}</p>
                </div>
              </div>
            </div>

            <div v-if="state === 'FREERESPIN' && (nextState === 'FREESPIN' || nextState === '-')"
              class="text-multiplier pt-2">
              <h1 class="my-1 green  justify-content-center"> {{ $t("veggiesbonanza.totalwin") }}
                {{ ((this.winAmounts)) | currencyFormatter }}
                <span class="multiplier-text">{{ ` X${this.multiplier}` }}</span>
                = {{ `${currency} ` }}{{ winlose | currencyFormatter }}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-aztec1000",
  props: {
    data: Object,
    page: Number,
    isback: Boolean
  },
  data() {
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      tokenData: utils.getTokenData(this.$route.query.t)
      ,
      date: "",
      time: "",
      currency: this.data.currency ? this.data.currency : "THB",
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      isFreespin: false,
      multiplier: 0,
      reels: [],
      reelSizes: [],
      reelsMultiplier: [],
      newReel: [],
      isEndRound: false,
      pages: 0,
      retrigger: false,
      scatterCount: 0,
      freespinFirstRound: false,
      freespinCount: 0,
      winAmounts: 0,
    };
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight =
        document.getElementsByClassName("header-aztec1000")[0].offsetHeight;
    },
    async mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }

      this.isGamble = result.state === "GAMBLE" ? true : false;
      this.freeSpinData = result.freeSpin;
      // this.freeSpinData.gambleThisRound = this.freeSpinData.gamble;
      // this.winGambleText = this.freeSpinData.totalWin > 0 ? "win" : "lose";
      // if (this.freeSpinData.totalWin <= 0) {
      //   this.freeSpinData.gambleThisRound =
      //     this.freeSpinData.gamble == "LOW" ? "HIGH" : "LOW";
      // }
      this.isFreespin =
        result.state === "FREESPIN" ||
        result.state === "FREERESPIN";
      this.isRespin = result.state === "RESPIN";
      this.state = result.state;
      this.nextState = result.nextState;

      this.reelSizes = result.reelSizes;
      this.reelsMultiplier = result.reelsMultiplier;
      this.multiplier = result.multiplier;

      this.retrigger = result.freeSpin && result.freeSpin.retrigger;
      this.freespinFirstRound = result.freeSpin.round == 0;
      this.scatterCount = 0;
      this.freespinCount = 0;
      this.winAmounts = result.winAmounts;

      if (this.retrigger) {
        this.freespinCount = result.freeSpin.retrigger;
      } else {
        this.freespinCount = result.freeSpin.remain;
      }

      result.reels.forEach(row => {
        row.forEach(num => {
          if (num === 11) this.scatterCount++;
        });
      });

      this.reels = result.reels;
      this.isEndRound = result.isEndRound;
      this.winlose = result.win;
      this.bet = result.bet;
      this.balance = result.balance;
      this.winnings = result.winnings;

      this.newReel = await this.mapTable(this.reels, this.reelSizes);

      if (result.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }

    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
    async mapTable(reel, reelSize) {
      let newMap = [];
      let newReel = [];
      for (let i = 0; i < reel.length; i++) {
        newReel = [];
        for (let j = 0; j < reel[i].length; j++) {
          let symbolMap = [reel[i][j], reelSize[i][j]];
          newReel.push(symbolMap);
        }
        newMap.push(newReel);
      }
      return newMap;
    },
  },
};
</script>

<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #172019;
  /* margin: 0; */
}

img {
  pointer-events: none;
  cursor: default;
}

.wheel-wrapper {
  position: absolute;
  width: 570px;
  height: 100%;
  top: 7px;
}

.fg-image {
  width: 570px;
}


.multiplier-wrapper {
  top: -95px;
  z-index: 6;
  height: 134px;
  overflow: hidden;
}

.multiplier-image {
  width: 90%;
  transform: scale(0.9);
  margin-left: 21px;
}

.icon-detail-aztec1000 {
  width: 100px;
  height: 80px;
  padding: 4px;
}

.icon-bonus-aztec1000 {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-aztec1000 {
  cursor: pointer;
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-aztec1000 {
  /* background: #0c161f; */
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.bonus-box-aztec1000 {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-aztec1000 .item {
  color: #fff;
  /* background: #06112d; */
  line-height: 1;
  border-radius: 10px;
  /* border: 1.5px solid #cac095; */
}

.bet-box-aztec1000 .bet-wrapper-aztec1000:not(:first-child) .item {
  /* margin-top: 10px;
  width: 800px; */
}

.bet-wrapper-aztec1000,
.result-wrapper {
  font-size: 35px;
  width: 800px;
}

.header-aztec1000 {
  background: #FDA000;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-aztec1000>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-aztec1000 {
  color: #FFFFFF;
  text-align: center;
}

.content-result-aztec1000 {
  background: #1C232A;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-aztec1000 {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-aztec1000 {
  color: #ffffff;
  font-size: 25px;
  text-align: center;
}

.text-collect-aztec1000 {
  color: #fff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-aztec1000 {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-subgame-aztec1000 {
  font-size: 20px;
  color: red;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #fff;
  text-align: center;
}

.icon-symbol-aztec1000 {
  width: 100%;
  /* height: 100%; */
  /* padding: 5%; */
}

.gamble-normal-aztec1000 {
  width: 40%;
  height: 35%;
  /* padding: 5%; */
}

.gamble-press-aztec1000 {
  width: 40%;
  height: 40%;
  /* padding: 5%; */
}

.gamble-img-aztec1000 {
  width: 70%;
  height: 70%;
  /* padding: 5%; */
}

.bet-box-aztec1000 {
  /* min-width: 600px;
  max-width: auto; */
}

.win-box {
  width: 760px;
}

.icon-symbol {
  position: absolute;
  transform: translate(-100%, 0%);
  width: 16.75%;
  /* height: 100%; */
}

.line-text,
.multiplier-text {
  color: red;
  font-size: 28px;
}

/* .icon-symbol.-level1 {
  width: 120;
  height: 89px;
}

.icon-symbol.-level2 {
  width: 120;
  height: 128;
  margin-left: -12px;
}

.icon-symbol.-level3 {
  width: 120;
  height: 330px;
  margin-left: -12px;
}

.icon-symbol.-level4 {
  width: 120;
  height: 442px;
  margin-left: -12px;
} */

.table-aztec1000 {
  /* background: url("~@/assets/resultGame/aztec1000/slotmachine.png") no-repeat; */
  z-index: 5;
  background-size: 763px 186px;
  /* set Bg Table HERE */
  width: 763px;
  height: 268px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
  margin-top: 48px;
  position: absolute;
  z-index: 0;
  transform: translate(0px, -130px);
}

.slot-container {
  position: relative;
}

.top-reel {
  display: flex;
  flex-direction: row;
  position: relative;
  width: 67%;
  transform: translate(24.5%, 0%);
}

.table-pos {
  transform: translate(0px, -7px);
}

.text-multiplier {
  width: 100%;
  text-align: center;
}

.line {
  background-color: #fff;
  height: 2px;
  width: 100%;
  font-size: 28px;
}

.red {
  color: #ff0000;
}

.green {
  color: #fff;
  font-size: 28px;
}

.win-box {
  width: 689px;
}



@media screen and (max-width: 1030px) {
  .table-aztec1000 {
    background-size: 760px 181px;
    width: 760px;
    height: 268px;
    transform: translate(0px, -124px);
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -107px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-aztec1000 {
    /* min-width: 580px;
    max-width: auto;
    height: 280px; */
  }

  .bet-wrapper-aztec1000 {
    width: 800px;
  }

  .result-wrapper {
    font-size: 35px;
    width: 800px;
  }

  .win-box {
    width: 689px;
  }

  .multiplier-box-veggiesbonanza {
    /* background: #0c161f; */
    border-radius: 10px;
    min-height: 50px;
    max-height: 100px;
    overflow-y: scroll;
    min-width: 100px;
    max-width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 800px;
  }
}

@media screen and (max-width: 1030px) {
  .table-aztec1000 {
    background-size: 760px 640px;
    width: 760px;
    height: 640px;
    transform: translate(0px, -55px);
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -107px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-aztec1000 {
    /* min-width: 580px;
    max-width: auto; */
    /* height: 280px; */
  }

  .bet-wrapper-aztec1000 {
    width: 800px
  }

  .result-wrapper {
    font-size: 35px;
    width: 800px
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (min-width: 1060px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -115px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 570px;
    margin-left: -34px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(1);
    margin-left: 21px;
  }

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-aztec1000,
  .result-wrapper {
    font-size: 33px;
    width: 800px;
  }
}

@media screen and (max-width: 900px) {
  .table-aztec1000 {
    background-size: 747px 645px;
    width: 747px;
    height: 645px;
    transform: translate(0px, -58px);
  }
}

@media screen and (max-width: 870px) {
  .table-aztec1000 {
    background-size: 729px 628px;
    width: 729px;
    height: 628px;
    transform: translate(-2px, -59px);
  }
}

@media screen and (max-width: 840px) {
  .table-aztec1000 {
    background-size: 699px 602px;
    width: 699px;
    height: 602px;
    transform: translate(0px, -57px);
  }
}

@media screen and (max-width: 800px) {
  .table-aztec1000 {
    background-size: 659px 569px;
    width: 659px;
    height: 569px;
    transform: translate(0px, -56px);
  }
}

@media screen and (max-width: 780px) {}

@media screen and (max-width: 770px) {
  .heading-aztec1000 {
    font-size: 18px;
  }

  .table-aztec1000 {
    background-size: 638px 550px;
    width: 638px;
    height: 550px;
    margin-bottom: 1%;
    transform: translate(0px, -55px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-aztec1000 {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-aztec1000 {
    /* min-width: 430px;
    max-width: auto; */
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 740px) {
  .heading-aztec1000 {
    font-size: 18px;
  }

  .table-aztec1000 {
    background-size: 614px 526px;
    width: 614px;
    height: 526px;
    margin-bottom: 1%;
    transform: translate(0px, -53px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-aztec1000 {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-aztec1000 {
    /* min-width: 430px;
    max-width: auto; */
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 710px) {
  .heading-aztec1000 {
    font-size: 18px;
  }

  .table-aztec1000 {
    background-size: 582px 500px;
    width: 582px;
    height: 500px;
    margin-bottom: 1%;
    transform: translate(-2px, -54px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-aztec1000 {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-aztec1000 {
    /* min-width: 430px;
    max-width: auto; */
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 680px) {
  .heading-aztec1000 {
    font-size: 18px;
  }

  .table-aztec1000 {
    background-size: 566px 482px;
    width: 566px;
    height: 482px;
    margin-bottom: 1%;
    transform: translate(-1px, -55px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-aztec1000 {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-aztec1000 {
    /* min-width: 430px;
    max-width: auto; */
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 650px) {
  .heading-aztec1000 {
    font-size: 18px;
  }

  .table-aztec1000 {
    background-size: 543px 470px;
    width: 543px;
    height: 470px;
    margin-bottom: 1%;
    transform: translate(0px, -56px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-aztec1000 {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-aztec1000 {
    /* min-width: 430px;
    max-width: auto; */
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 620px) {
  .heading-aztec1000 {
    font-size: 18px;
  }

  .table-aztec1000 {
    background-size: 516px 444px;
    width: 516px;
    height: 444px;
    margin-bottom: 1%;
    transform: translate(-2px, -53px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-aztec1000 {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-aztec1000 {
    /* min-width: 430px;
    max-width: auto; */
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 600px) {
  .table-aztec1000 {
    background-size: 498px 430px;
    width: 498px;
    height: 430px;
    transform: translate(0px, -54px);
  }
}

@media screen and (max-width: 570px) {
  .table-aztec1000 {
    background-size: 474px 410px;
    width: 474px;
    height: 410px;
    transform: translate(0px, -53px);
  }
}

@media screen and (max-width: 540px) {
  .table-aztec1000 {
    background-size: 450px 390px;
    width: 450px;
    height: 390px;
    transform: translate(-1px, -54px);
  }

  .text-multiplier {
    width: 100%;
    text-align: center;
  }
}

@media screen and (max-width: 510px) {
  .table-aztec1000 {
    background-size: 425px 367px;
    width: 425px;
    height: 367px;
    transform: translate(0px, -54px);
  }
}

@media screen and (max-width: 480px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-aztec1000>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-aztec1000 {
    font-size: 12px;
  }

  .table-aztec1000 {
    background-size: 399px 344px;
    width: 399px;
    height: 344px;
    transform: translate(-1px, -53px);
  }

  .text-subhead-aztec1000 {
    font-size: 14px;
  }

  .bet-box-aztec1000 {
    /* min-width: 230px;
    max-width: auto; */
    /* height: 200px; */
  }

  .bonus-box-aztec1000 {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-aztec1000 {
    width: 422px;
  }

  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-aztec1000 {
    width: 50px;
    height: 50px;
  }

  .text-win {
    height: 60px;
  }

  .text-multiplier {
    width: 100%;
    text-align: center;
  }

  .icon-bonus-aztec1000 {
    width: 60px;
    height: 60px;
  }
}

@media screen and (max-width: 450px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-aztec1000>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-aztec1000 {
    font-size: 12px;
  }

  .table-aztec1000 {
    background-size: 375px 324px;
    width: 375px;
    height: 324px;
    transform: translate(-1px, -53px);
  }

  .text-subhead-aztec1000 {
    font-size: 14px;
  }

  .bet-box-aztec1000 {
    /* min-width: 230px;
    max-width: auto; */
    /* height: 200px; */
  }

  .bonus-box-aztec1000 {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-aztec1000 {
    width: 422px;
  }

  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-aztec1000 {
    width: 50px;
    height: 50px;
  }

  .text-multiplier {
    width: 100%;
    text-align: center;
  }

  .icon-bonus-aztec1000 {
    width: 60px;
    height: 60px;
  }
}

@media screen and (max-width: 420px) {

  .table-aztec1000 {
    background-size: 350px 300px;
    width: 350px;
    height: 300px;
    transform: translate(1px, -52px);
  }
}

@media screen and (max-width: 390px) {

  .table-aztec1000 {
    background-size: 325px 280px;
    width: 325px;
    height: 280px;
    transform: translate(0px, -53px);
  }
}

@media screen and (max-width: 360px) {

  .table-aztec1000 {
    background-size: 300px 100px;
    width: 399px;
    height: 180px;
    transform: translate(0px, -93px);
  }

}

@media screen and (max-width: 340px) {

  .table-aztec1000 {
    background-size: 279px 100px;
    width: 399px;
    height: 180px;
    transform: translate(2px, -93px);
  }
}

@media screen and (max-width: 320px) {

  .table-aztec1000 {
    background-size: 259px 64px;
    width: 399px;
    height: 180px;
    transform: translate(4px, -76px);
  }
}
</style>